module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.total > _vm.currentLimit) ? _c('div', {
    staticClass: "vue-tiny-pagination pagination layout",
    staticStyle: {
      "justify-content": "center",
      "-webkit-justify-content": "center"
    }
  }, [_c('ul', {
    staticClass: "tiny-pagination",
    class: _vm.customClass
  }, [_c('li', {
    staticClass: "page-item",
    class: _vm.classFirstPage
  }, [_c('button', {
    staticClass: "pagination__navigation primary",
    class: _vm.classFirstPage,
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.lastPage($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("arrow_left")])])]), _vm._v(" "), _c('li', {
    staticClass: "page-item ml-4",
    class: _vm.classLastPage,
    staticStyle: {
      "margin-right": "0"
    }
  }, [_c('button', {
    staticClass: "pagination__navigation primary",
    class: _vm.classLastPage,
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextPage($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("arrow_right")])])])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-96f97b52", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96f97b52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination2.vue
// module id = 535
// module chunks = 1